export default "__VITE_ASSET__eDz8Kuuv__"